export enum ModoVenda {
  VENDA_PADRAO = 'V',
  VENDA_A_ORDEM = 'A',
  ENTREGA_FUTURA = 'U',
  BONIFICACAO_OU_BRINDE = 'B',
  VENDA_AMBULANTE = 'F',
  SAIDA_DEPOSITO = 'D',
  USO_E_CONSUMO = 'N',
  CONTA_E_ORDEM = 'C',
  PRO_EMPREGO = 'E',
}

export namespace ModoVenda {
  export function getDescricao(modo: ModoVenda): string {
    switch (modo) {
      case ModoVenda.VENDA_PADRAO: return 'Venda Padrão';
      case ModoVenda.VENDA_A_ORDEM: return 'Venda à Ordem';
      case ModoVenda.ENTREGA_FUTURA: return 'Entrega Futura';
      case ModoVenda.BONIFICACAO_OU_BRINDE: return 'Bonificação/Brinde';
      case ModoVenda.VENDA_AMBULANTE: return 'Venda Ambulante';
      case ModoVenda.SAIDA_DEPOSITO: return 'Saída Depósito';
      case ModoVenda.USO_E_CONSUMO: return 'Uso e Consumo';
      case ModoVenda.CONTA_E_ORDEM: return 'Conta e Ordem';
      case ModoVenda.PRO_EMPREGO: return 'Pró Emprego';
      default: return '';
    }
  }
}